<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title"><i class="mdi mdi-calendar-multiple"></i>&nbsp;Purchase Orders Checkout</h4>
                                <h5 class="card-subtitle">Checkout Summary of all Marked Purchase Orders</h5>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Supplier</th>
                                    <th>Product Number</th>
                                    <th>Product</th>
                                    <th>Price</th>
                                    <th>Taxes</th>
                                    <th>Total</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(cp, index) in checkedPos">
                                    <td>{{index+1}}</td>
                                    <td :rowspan="itemsLength" v-if="index === 0">{{cp.seller.biz_name}}</td>
                                    <td>{{cp.number}}</td>
                                    <td>{{cp.name}}</td>
                                    <td>{{cp.total | money}}</td>
                                    <td class="font-500" v-if="cp.tax">{{cp.tax}}</td>
                                    <td class="font-500" v-if="!cp.tax">0.00</td>
                                    <td class="font-500">{{cp.total | money}}</td>
                                </tr>
                                <tr>
                                    <td align="right" class="font-500" colspan="6">Grand Total</td>
                                    <td class="font-500">{{grandTotal | money}}</td>
                                </tr>
                                </tbody>
                            </table>
                            <div aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" id="confirmModal" role="dialog" tabindex="-1">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-body card-blue">
                                            <div class="text-center m-t-20 m-b-10">
                                                <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px"></i>
                                                <br><br>
                                                <h4>Are you sure you want to make payment of {{grandTotal | money}}</h4>
                                                <button @click="payPo()" class="btn waves-effect waves-light btn-success m-r-15" data-dismiss="modal" type="button">Yes</button>
                                                <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">No</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="float-right">
                            <button class="btn btn-info" data-target="#confirmModal" data-toggle="modal">Make Payment</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from 'lodash';
    import Money from "../../../../models/Money";

    export default {
        name: "PurchaseOrderCheckout",
        props: ['checkedPos'],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                itemsLength: 0,
                grandTotal: 0
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                this.itemsLength = this.checkedPos.length;
                this.grandTotal  = {
                    amount: _.sumBy(this.checkedPos, 'total.amount'),
                    currency_id: this.checkedPos[0].total.currency_id,
                    currency_name: this.checkedPos[0].total.currency_name,
                    currency_symbol: this.checkedPos[0].total.currency_symbol
                };
            },
            async payPo() {
                let total = new Money(this.grandTotal);
                let poids = _.map(this.checkedPos, 'id');
            }
        }
    }
</script>

<style scoped>

</style>
